import { render, staticRenderFns } from "./EditAdvert.vue?vue&type=template&id=5daa1a11"
import script from "./EditAdvert.vue?vue&type=script&lang=js"
export * from "./EditAdvert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports